import React from "react";
import { Box, Typography, List, ListItem } from "@mui/material";

const CouncilAnnouncement = () => {
  return (
    <Box
      p={4}
      sx={{
        lineHeight: 1.5,
        width: {
          xs: "100%",
          lg: "60%",
        },
        mx: "auto",
      }}
    >
      {/* Header */}
      <Typography variant="h5" align="center" fontWeight="bold" gutterBottom>
        ԱԶԳԱՅԻՆ ԿՐԹՈՒԹՅԱՆ ԽՈՐՀՐԴԻ ՀԱՅՏԱՐԱՐՈՒԹՅՈՒՆԸ
      </Typography>

      <Typography
        variant="body1"
        align="center"
        sx={{ whiteSpace: "pre-line" }}
        gutterBottom
      >
        --------------------‐--------------------‐
      </Typography>

      <Typography variant="body1" mt={3}>
        Ամփոփելով «Հայաստանի քանդվող ապագան` փակվող դպրոցներ» աշխատաժողովի
        արդյունքները՝ արձանագրում ենք․
      </Typography>

      {/* Section 1 */}
      <Typography variant="body1" mt={3}>
        1․ 2026 թվականի սեպտեմբերի 1-ից «Հայաստանի Հանրապետության կրթության
        որակյալ ծառայությունների ապահովման ծրագրի» քողի տակ նախատեսվող թվով 229
        հանրակրթական դպրոցների փակման գործընթացի հետևանքներն ուղղակի սպառնալիք
        են պետության անվտանգությանը, քանի որ այն հանգեցնելու է․
      </Typography>

      <List
        sx={{
          mt: 1,
          listStyleType: "disc",
          pl: 2,
          ml: 0,
        }}
      >
        <ListItem sx={{ display: "list-item" }}>
          Ա․ Կրթության ոլորտում՝ հանրապետական ցանցի համակարգային քանդման,
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          Բ․ Ժողովրդագրական ոլորտում՝ գյուղերի դատարկման և «մահվան»,
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          Գ․ Տարաբնակեցման ոլորտում՝ համակարգի կենսունակության փլուզման,
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          Դ․ Սոցիալ-տնտեսական ոլորտում՝ տեղական տնտեսությունների ոչնչացման,
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          Ե․ Անվտանգության ոլորտում՝ սահմանների խոցելիության և ֆիզիկական
          անվտանգության բարձրացման, և այս ամենով հանդերձ պետականության գոյատևման
          սպառնալիքի։
        </ListItem>
      </List>

      {/* Section 2 */}
      <Typography variant="body1" mt={3}>
        2․ Անհրաժեշտ է ձևավորել դիմադրության հանրային լայն ճակատ, որպեսզի
        չեղարկվի պետականակործան այս ծրագիրը, որի համար անհրաժեշտ է․
      </Typography>

      <List
        sx={{
          mt: 1,
          listStyleType: "disc",
          pl: 2,
          ml: 0,
        }}
      >
        <ListItem sx={{ display: "list-item" }}>
          Ա․ Ծրագրի կործանարար հետևանքների վերաբերյալ տեղեկատվությունը հասանելի
          դարձնել մարզերում՝ հանրային քննարկումների միջոցով․
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          Բ․ Փակվող դպրոցների աշխատակազմի, ծնողների և գյուղաբնակների
          ինքնակազմակերպմամբ ձևավորել սեփական շահերի պաշտպանության տեղական
          կենտրոններ,
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          Գ․ Հասարակական ազգային կառույցների ներկայացուցիչներից ձևավորել
          մասնագիտական հանձնաժողով՝ գործընթացի հետևանքների առավել մանրակրկիտ
          ուսումնասիրության և հանրությանը ներկայացնելու համար,
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          Դ․ ՀՀ օրենքի սահմաններում իրականացնել հանրային լայն ճնշում,
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          Ե․ Համապատասխան որոշումները չեղարկելու համար ապահովել դատաիրավական
          գործընթացի մեկնարկ։
        </ListItem>
      </List>

      {/* Section 3 */}
      <Typography variant="body1" mt={3}>
        3․ Կոնկրետ աշխատաժողովին ՀՀ ԿԳՄՍՆ-ի անսպասելի արագ արձագանքի վերաբերյալ․
      </Typography>

      <List
        sx={{
          mt: 1,
          listStyleType: "disc",
          pl: 2,
          ml: 0,
        }}
      >
        <ListItem sx={{ display: "list-item" }}>
          Ա․ Շղարշող եզրույթներն ու բառախաղերը չեն փոխում իրականությունը։ Ինչպես
          էլ ձևակերպվի երևույթը, «Ազգային կրթության խորհուրդը» վերահաստատում է,
          որ այս պահին դեռ ուժի մեջ է հանրապետության թվով 229 հանրակրթական
          դպրոցներում 2026 թվականի սեպտեմբերի 1-ից ուսումնական գործընթացի
          դադարեցման որոշումը, այսինքն՝ դպրոցների փակման գործընթացը։ Ավելին, այն
          ապահովելու քայլերն արդեն իրականացվում են, և թիրախ խմբերը՝ ուսուցիչներ,
          աշակերտներ, ծնողներ ու գյուղաբնակներ, արդեն ներգրավված են
          գործընթացում։
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          Բ․ Ցավով ենք արձանագրում, որ նույնիսկ ԿԳՄՍՆ-ում չեն կարող ընկալել և
          տարբերակել իրականությունը բառախաղային ձևակերպումներից։ Իսկ, եթե
          ընկալում և տարբերակում են, ապա նրանց գործունեությունը կարելի է
          բնութագրել հասարակությանը մոլորեցնելու դիտավորյալ քայլ։
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          Գ․ «Ազգային կրթության խորհուրդը» պատրաստ է ԿԳՄՍՆ ցանկացած
          պատասխանատուի հետ, ցանկացած ձևաչափով և հարթակով, ցանկացած տիպի՝
          գիտական, մասնագիտական ու հանրային բաց բանավեճի։
        </ListItem>
      </List>

      {/* Footer */}
      <Typography variant="body1" mt={4} fontWeight="bold">
        «Ազգային կրթության խորհուրդ»
      </Typography>

      <Typography variant="body1" mt={1}>
        21․02․2026
      </Typography>
    </Box>
  );
};

export default CouncilAnnouncement;
